document.addEventListener('DOMContentLoaded', () => {
  const featuredteam = document.querySelector('.pottd-featured-team');

  if (featuredteam !== null) {
    new Splide(featuredteam, {
      classes: {
        pagination: 'splide__pagination your-class-pagination',
        page: 'splide__pagination__page your-class-page',
      },
      pagination: false,
      type: 'loop',
      perPage: 3,
      perMove: 1,
      focus: 'center',
      arrows: true,
      breakpoints: {
        1024: {
          arrows: false,
          padding: { left: 0, right: 0 },
        },
      },
    }).mount();
  }
  const splideproduct = document.querySelector('.pottd-splide-product');

  if (splideproduct !== null) {
    new Splide(splideproduct, {
      pagination: false,
      type: 'loop',
      focus: 'center',
      autoplay: true,
      interval: 1000, // Altere este valor para o intervalo desejado (2500ms = 2.5 segundos)
      speed: 2000, // Altere este valor para a duração da transição entre slides (1000ms = 1 segundo)
      arrows: false,
      breakpoints: {
        1024: {
          arrows: false,
          padding: { left: 0, right: 0 },
        },
      },
    }).mount();
  }

  if (window.innerWidth <= 720) {
    const splideContainer = document.querySelector('.splide.plp-splide');

    if (splideContainer !== null) {
      new Splide(splideContainer, {
        type: 'slide',
        perMove: 1,
        arrows: false,
        pagination: false,
        padding: { left: 12, right: 12 },
      }).mount();
    }
  }

  if (window.innerWidth <= 768) {
    const featuredBrands = document.querySelector('.pottd-featured-brands');

    if (featuredBrands !== null) {
      new Splide(featuredBrands, {
        type: 'loop',
        perMove: 1,
        fixedWidth: '30%',
        arrows: false,
        pagination: false,
        gap: 20,
        padding: '10%',
      }).mount();
    }

    const howToUse = document.querySelector('.how-to-use.splide');

    if (howToUse !== null) {
      new Splide(howToUse, {
        type: 'slide',
        perMove: 1,
        perPage: 1,
        arrows: false,
        pagination: false,
      }).mount();
    }
  }

  const bannerSplide = document.querySelector('.pottd-slideshow.splide');

  if (bannerSplide !== null) {
    new Splide(bannerSplide, {
      arrows: false,
      pagination: true,
      type: 'slide',
      autoplay: true,
      interval: 10000,
      pauseOnHover: true,
      rewind: true,
    }).mount();
  }

  const slidingItems = document.querySelectorAll('.sliding-items');

  if (slidingItems.length !== 0) {
    slidingItems.forEach((item) => {
      const gap = Number(item.dataset.gap);
      const blocksMobile = Number(item.dataset.blocksMobile);
      const blocksDesktop = Number(item.dataset.blocksDesktop);

      new Splide(item, {
        arrows: false,
        pagination: false,
        perPage: blocksDesktop,
        type: 'slide',
        gap: gap,
        breakpoints: {
          768: {
            perPage: blocksMobile,
            padding: { left: '1.5rem', right: '1.5rem' },
          },
        },
      }).mount();
    });
  }

  const jumpBannerSplide = document.querySelectorAll('.jump-slideshow.splide');
  if (jumpBannerSplide.length !== 0) {
    jumpBannerSplide.forEach((item) => {
      new Splide(item, {
        arrows: false,
        pagination: true,
        type: 'slide',
        autoplay: true,
        interval: 4000,
        pauseOnHover: true,
        rewind: true,
      }).mount();
    });
  }

  const slidingCards = document.querySelectorAll('.sliding-cards');

  if (slidingCards.length !== 0) {
    slidingCards.forEach((slidingCard) => {
      const gap = Number(slidingCard.dataset.gap);
      const blocksMobile = Number(slidingCard.dataset.blocksMobile);
      const blocksDesktop = Number(slidingCard.dataset.blocksDesktop);

      new Splide(slidingCard, {
        arrows: false,
        pagination: false,
        perPage: blocksDesktop,
        type: 'slide',
        gap: gap,
        breakpoints: {
          768: {
            perPage: blocksMobile,
            padding: { right: '5rem' },
          },
        },
      }).mount();
    });
  }

  const featuredProducts = document.querySelectorAll('.featured_product_media');

  if (featuredProducts.length !== 0) {
    featuredProducts.forEach((media) => {
      const mediaSplide = new Splide(media, {
        arrows: false,
        pagination: false,
        perPage: 1,
        type: 'slider',
        gap: 4,
      });

      mediaSplide.mount();

      const splideEvent = new CustomEvent('mountedFeaturedSplide', {
        detail: {
          component: mediaSplide,
        },
      });

      document.dispatchEvent(splideEvent);

      mediaSplide.on('move', (events) => {
        const splideEventMove = new CustomEvent('movingSplideEvent', {
          detail: {
            index: events,
          },
        });

        document.dispatchEvent(splideEventMove);
      });
    });
  }
});

document.addEventListener('finished-products', () => {
  const recommendationContainer = document.querySelector('.contains-card.splide');

  if (recommendationContainer !== null) {
    new Splide(recommendationContainer, {
      type: 'slide',
      perMove: 1,
      fixedWidth: 338,
      arrows: false,
      pagination: false,
      gap: 10,
      mediaQuery: 'min',
      padding: { left: 12, right: 12 },
      breakpoints: {
        768: {
          padding: { left: 40, right: 40 },
        },
        1280: {
          arrows: true,
          padding: { left: 0, right: 0 },
        },
      },
    }).mount();
  }
});

document.addEventListener('mountedFeaturedSplide', (e) => {
  const featuredPagination = document.querySelector('.featured__pagination');

  if (featuredPagination !== null) {
    const pagination = new Splide(featuredPagination, {
      arrows: true,
      pagination: false,
      perPage: 3,
      type: 'slider',
      gap: '1rem',
      mediaQuery: 'min',
      breakpoints: {
        1024: {
          perPage: 4,
        },
      },
    });

    pagination.mount();

    const paginationPoints = featuredPagination.querySelectorAll('.pagination-slide');

    const mediaSplide = e.detail.component;

    paginationPoints.forEach((point, index) => {
      point.addEventListener('click', () => {
        mediaSplide.go(index);

        paginationPoints.forEach((point) => {
          point.classList.remove('active-pagination');
        });

        point.classList.add('active-pagination');
      });
    });

    document.addEventListener('movingSplideEvent', (e) => {
      const index = e.detail.index;

      pagination.go(index);

      paginationPoints.forEach((point) => {
        point.classList.remove('active-pagination');
      });

      paginationPoints[index].classList.add('active-pagination');
    });
  }
});
